<template>
  <div class="exerciseDetail">
    <!-- 做题进度 -->
    <div class="timerProgress">
      <dl class="progressLine">
        <dt v-show="teskDetail.position">{{teskDetail.position}}/{{teskDetail.total}}</dt>
        <dd>
          <div class="progress" :style="'width:'+processRatio+'%'"></div>
        </dd>
      </dl>
    </div>
    <Question :teskDetail="teskDetail" :selectBl="true" @selectFn="selectFn"></Question>

    <div class="submitContainer">
      <div class="submitWrapper">
        <div class="btn submitBtn" @click.stop="answerQuestion">我也要练习</div>
      </div>
    </div>
    <div class="tipBtn" v-show="teskDetail.questionType == 'TEXT' && !teskDetail.analysis" @click.stop="showIdea">思路点播</div>
    <div class="rightTip" v-show="greatShow"><img src="@/assets/img/question/great.png" alt=""></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Question from '@com/list/Question.vue'

import { appPort, getTokenObj, userLogin, weixinShare } from "@/widget/index";
import { getShareQuizDetail, getCheckPaper } from '@api/exercise'
import { hostPath } from '@/public/utils/basePath';
export default defineComponent({
  data() {
    return {
      teskDetail: {},
      collectBl: false,
      greatShow: false,
      timeOut: null,
      done: false, // 是否做题
      radio: '',
      checkbox: [],
      processRatio: 0,
      nextBtn: false,
      isApp: appPort(),
      isLogin: true,
      checkData: {},
      questionId: this.$route.query.questionId || '',
      paperId: this.$route.params.id,
      taskId: this.$route.query.taskId,
      shareInfo: {
        title: '邀请你一起参加病例练习，快速提升诊疗思维',
        desc: '丰富的病例，助您每日精进',
        url: hostPath + `/learn${this.$route.fullPath}`,
        image: 'https://img-a.haoyishu.com/images/share/hys_logo.png'
      }
    }
  },
  methods: {
    backFn() {
      this.$dialog.confirm({
        title: '确定退出练习？',
        message: '还未完成练习，将为你自动保留'
      }).then(() => {
        history.go(-1);
      }).catch(() => {
        // console.log(1212)
      })
    },
    showIdea() {
      this.$dialog.alert({
        title: '解析(仅供参考)',
        messageAlign: 'left',
        message: this.teskDetail.hint,
        confirmButtonText: '有思路了'
      })
    },
    selectFn() {
      this.answerQuestion();
    },
    answerQuestion() {
      if (this.isLogin) {
        // 判断是否是会员或免费
        if (this.checkData.free || this.checkData.purchased) {
          let query = this.getQuery();
          this.$router.push({
            name: `ExamDetail`,
            params: {
              id: this.teskDetail.exerciseId
            },
            query
          })
        } else {
          let query = this.getQuery();
          // 进入导览页
          this.$router.push({
            name: `guideExercise`,
            query
          })
        }
      } else {
        let query = this.getQuery();
        query.exerciseId = this.teskDetail.exerciseId;
        userLogin({ query });
      }
    },
    getDetail() {
      this.$showLoading()
      getShareQuizDetail({
        questionId: this.questionId,
        paperId: this.paperId,
        taskId: this.taskId
      }).then(res => {
        this.$hideLoading();
        if (res.code === 200) {
          let r = JSON.parse(JSON.stringify(res.data))
          delete r.answer;
          delete r.analysis;
          r.ratio = null;
          this.teskDetail = r;
          this.processRatio = (parseInt(this.teskDetail.position) / parseInt(this.teskDetail.total)) * 100;
          if (this.isLogin) {
            getCheckPaper({
              exerciseId: res.data.exerciseId
            }).then(res => {
              if (res.code === 200) {
                this.checkData = res.data;
              } else {
                this.$toast(res.message)
              }
            })
          }
        } else {
          this.$toast(res.message);
        }
      })
    },
    getQuery() {
      let query = {};
      let depId = this.$route.query.depId;
      let sourceId = this.$route.query.sourceId;
      if (depId) {
        query.depId = depId;
      }
      if (sourceId) {
        query.sourceId = sourceId;
      }
      return query;
    }
  },
  mounted() {
    // 判断是否登录
    this.isLogin = !!getTokenObj().token;
    this.getDetail();
    // console.log(this.shareInfo.url)
    weixinShare(this.shareInfo)
  },
  components: {
    Question
  }
})
</script>

<style lang="scss" scoped>
.shareWrapper {
  height: 88px;
  display: flex;
  align-items: center;
  padding-left: 14px;
}
.exerciseDetail {
  min-height: 100vh;
  .collectBtn {
    height: 87px;
    line-height: 87px;
    padding-right: 32px;
    font-size: 28px;
    color: #222;
    .van-icon-star, .van-icon-star-o {
      font-size: 34px;
      margin-right: 4px;
      font-weight: bold;
    }
    .van-icon-star {
      color: $themeColor;
    }
  }
}
.timerProgress {
  display: flex;
  height: 66px;
  padding: 20px 32px;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 1;
}
.progressLine {
  height: 40px;
  position: relative;
  display: flex;
  font-size: 32px;
  align-items: center;
  dd {
    height: 14px;
    width: 170px;
    overflow: hidden;
    border-radius: 7px;
    margin-left: 10px;
    background: #F5F5F7;
  }
  .progress {
    height: 14px;
    /*width: 20%;*/
    background: $themeColor;
    border-radius: 7px;
  }
}
.questBook{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 32px 12px;
  height: 66px;
  line-height: 66px;
  background: linear-gradient(90deg, #FFE3CE 0%, #FFF8F3 100%);
  .questBook-l{
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #212224;
  }
  .questBook-r{
    font-size: 32px;
    font-family: Helvetica;
    color: #212224;
  }
}
.submitContainer {
  width: 100%;
  height: 128px;
  margin: 0 auto;
  font-size: 32px;
  .submitWrapper {
    height: 128px;
    width: 750px;
    box-sizing: border-box;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 54%;
    margin-left: -375px;
    background: #fff;
    box-shadow: 0 1Px rgba(177,177,179, 0.25) inset;
    z-index: 999;
  }
  .btn {
    width: 625px;
    height: 88px;
    border-radius: 44px;
    text-align: center;
    line-height: 88px;
    text-align: center;
  }
  .prevBtn {
    background: #F5F5F7;
    color: #FF6600;
  }
  .nextBtn, .submitBtn {
    background: #FF6600;
    color: #fff;
  }
  /* .submitBtn {
    opacity: 0.5;
  } */
  .canSubmit {
    opacity: 1;
  }
}
.tipBtn {
  width: 116px;
  height: 64px;
  background: url('~@/assets/icon/question/tip_idea.png') no-repeat center;
  background-size: 116px 64px;
  position: fixed;
  bottom: 208px;
  left: 50%;
  margin-left: 622 - 375px;
  text-align:  center;
  line-height: 64px;
  color: #fff;
  font-size: 22px;
  z-index: 666;
}
.rightTip {
  width: 240px;
  height: 120px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-top: -60px;
  margin-left: -120px;
  animation: zoomIn 0.2s linear;
  img {
    width: 100%;
  }
}
</style>
